import { CardPrograms } from './CardPrograms';
import { CardAnatomy } from './CardAnatomy';
import { NotificationExamples, PrintMaterials, ProductDetails } from './ProductStories';

export function ProductFeatures() {
  return (
    <>
      <div className="wallet-features wallet-features--refined">
        <article
          className="wallet-feature wallet-feature--native"
          aria-labelledby="native-title"
        >
          <div className="feature-art wallet-art official-wallets">
            <div className="official-wallet-brand official-wallet-brand--apple">
              <img
                src="/images/apple-wallet-icon.png"
                width="512"
                height="512"
                alt="Apple Wallet"
              />
              <span aria-hidden="true">Apple Wallet</span>
            </div>
            <div className="official-wallet-brand official-wallet-brand--google">
              <img
                src="/images/google-wallet-official.svg"
                width="155"
                height="29"
                alt="Google Wallet"
              />
            </div>
          </div>
          <div className="feature-copy">
            <h3 id="native-title">Já está no celular.</h3>
            <p>
              Seu cartão na Apple Wallet e na Google Wallet. Sem papel para
              guardar. Sem outro aplicativo para baixar.
            </p>
          </div>
        </article>
        <article
          className="wallet-feature wallet-feature--messages"
          aria-labelledby="messages-title"
        >
          <div className="feature-art feature-art--photo">
            <img
              src="/images/feature-communication.avif"
              alt="Ilustração de uma mensagem do Café Aurora na tela do celular"
              width="1024"
              height="1024"
              loading="lazy"
            />
          </div>
          <div className="feature-copy">
            <h3 id="messages-title">Programe. Deixe acontecer.</h3>
            <p>
              Envie novidades para o cartão. Agende campanhas diárias, semanais
              ou mensais para quem autorizou receber.
            </p>
          </div>
        </article>
        <article
          className="wallet-feature wallet-feature--location"
          aria-labelledby="location-title"
        >
          <div className="feature-art feature-art--photo">
            <img
              src="/images/feature-location.avif"
              alt="Ilustração de uma cafeteria e sua área de proximidade no mapa"
              width="1024"
              height="1024"
              loading="lazy"
            />
          </div>
          <div className="feature-copy">
            <h3 id="location-title">Por perto, na hora certa.</h3>
            <p>
              Lembretes para quando o cliente estiver por perto. Em preparação,
              com uso sujeito às permissões do celular e da carteira.
            </p>
          </div>
        </article>
      </div>
      <CardPrograms />
      <CardAnatomy />
      <NotificationExamples />
      <PrintMaterials />
      <ProductDetails />
    </>
  );
}
